import { render, staticRenderFns } from "./ProcesoEndoso.vue?vue&type=template&id=bc8fe97a&"
import script from "./ProcesoEndoso.vue?vue&type=script&lang=js&"
export * from "./ProcesoEndoso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports